module.exports = __webpack_public_path__ + "static/media/sorrya33b00f67cc454d88ca96133f6cb5834.webp";